import React, { ReactNode } from 'react';
import { ToastContext, useToastState } from '../../hooks/useToast';

interface ToastProviderProps {
  children: ReactNode;
}

export const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  const toastState = useToastState();

  return (
    <ToastContext.Provider value={toastState}>
      {children}
    </ToastContext.Provider>
  );
};

export default ToastProvider; 